<template>
    <MainHeaderComponent :activePage="activePage"/>
    <StaffPage v-if="mode == 'staffs'" v-model:mode="mode"/>
    <ScheduleAndSalary v-else-if="mode == 'schedule-and-salary'" v-model:mode="mode"/>
</template>


<script>
    import { mapState } from 'vuex';

    import MainHeaderComponent from '@/components/laptop/MainHeaderComponent.vue';
    import StaffPage from '@/components/laptop/Staff/StaffPage.vue';
    import ScheduleAndSalary from '@/components/laptop/Staff/ScheduleAndSalary.vue';

    export default {
        name: "StaffView",
        components: {
            StaffPage,
            MainHeaderComponent,
            ScheduleAndSalary,
        },
        data() {
            return {
                activePage: "staffs",
                dataIsLoaded: false,
                mode: "schedule-and-salary",
            }
        },
        computed: {
            ...mapState(["companyData"]),
        },
        methods: {
            initData() {
                // if (this.$route.name == "schedule-and-salary") {
                //     if (!this.companyData.plan.schedule_and_salary_plugin_is_active) {
                //         this.$router.push({name: "dashboard"});
                //         return;
                //     }
                //     this.mode = "schedule-and-salary";
                // } else {
                //     this.mode = "staffs";
                // }
            }
        },
        mounted() {
            this.initData();
        }
    };
</script>